export type Breakpoints = { [breakpoint: string]: number };

export const breakpoints: Breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
